"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_component_1 = require("../map.component");
const _4d_mapper_1 = require("4d-mapper");
const core_2 = require("@ngx-translate/core");
const BaseComponent_1 = require("../../../commons/BaseComponent");
const map_service_1 = require("../../../commons/map.service");
const rxjs_1 = require("rxjs");
const app_service_1 = require("../../../commons/app.service");
const common_1 = require("@angular/common");
const map_data_service_1 = require("../../../v2/commons/map-data.service");
const Cesium = window.Cesium;
class ProcessingDetailsComponent extends BaseComponent_1.BaseComponent {
    constructor(route, router, snackBar, dialog, location, mapComp, mapService, trans, fourD, service, dataService) {
        super(router, snackBar, dialog);
        this.route = route;
        this.router = router;
        this.location = location;
        this.mapComp = mapComp;
        this.mapService = mapService;
        this.trans = trans;
        this.fourD = fourD;
        this.service = service;
        this.dataService = dataService;
        this.batches = [];
        this.arguments = {};
        this.files = [];
        mapComp.setTab('processing');
        this.dataService.onSceneReady().subscribe(s => {
            route.params.subscribe(params => {
                let incomingId = parseInt(params.id);
                if (params.type == 'job') {
                    this.jobType = this.fourD.jobTypes.find(j => j.id == incomingId);
                    if (incomingId == 99999999) {
                    }
                    else if (!this.jobType) {
                        console.log('!!!', params);
                        return;
                    }
                    if (this.jobType.baseTransform) {
                        this.qMap = this.jobType.baseTransform.qMap;
                    }
                    if (params.jid == 'new') {
                        this.job = new _4d_mapper_1.Job(this.fourD.V);
                        this.job.jobType = this.jobType;
                        this.job.account = this.fourD.activeTeam;
                        this.job.name = "New " + this.jobType.name;
                        this.job.scene = this.dataService.scene.value;
                        this.dataService.sceneJobs.add(this.job);
                        this.job.saveObservable().subscribe();
                    }
                    else {
                        var existing = this.dataService.sceneJobs.values.find(v => params.jid == '' + v.id);
                        if (existing) {
                            this.job = existing;
                            this.refreshFiles();
                            existing.batches().queryObservable().subscribe(r => this.batches = r.items);
                        }
                        else {
                            this.openDialog('MAP.PHOTOGRAM.JOB_LOCATON', 'MAP.PHOTOGRAM.JOB_ID ' + params.jid + ' MAP.PHOTOGRAM.NOT_FOUND');
                        }
                    }
                }
                else {
                    this.transformType = this.fourD.transformTypes.find(j => j.id == parseInt(params.id));
                    this.qMap = this.transformType['qMap'];
                    this.transformType.apis.queryObservable().subscribe(res => {
                        if (res.items.length) {
                            this.api = res.items[0];
                            this.qMap = this.api['qMap'];
                        }
                    });
                }
                console.log('@@@@@ job', params, this.job);
                mapComp.detailsNav.open();
            });
        });
    }
    destroy() {
        if (this.job && !this.job.id) {
            this.dataService.sceneJobs.remove(this.job);
        }
    }
    refreshFiles() {
        this.job.inputDatasets.queryObservable().subscribe(s => {
            this.arguments = {};
            this.files = s.items;
            var initParams = s.items.find(element => !!element.initParams && !!Object.keys(element.initParams).length);
            if (initParams) {
                var qMap = this.qMap;
                this.arguments = initParams.initParams;
                this.qMap = null;
                // bit hacky for qMap to redraw
                setTimeout(() => this.qMap = qMap, 100);
            }
        });
    }
    pickFiles() {
        this.openDialogWithModeAndFilterAndMeta({
            project: this.mapService.currentProject
        }, 'file_all', 'Dataset', 'PROJECT.DIALOG.ADD_TRANSFORM_TITLE', 'PROJECT.DIALOG.ADD_TRANSFORM_TEXT').subscribe(dest => {
            if (this.jobType) {
                var addFiles = () => {
                    var obs = null;
                    if (dest instanceof _4d_mapper_1.Folder) {
                        obs = this.job.inputFolders.addObserveable(dest);
                    }
                    else if (dest && Array.isArray(dest)) {
                        obs = rxjs_1.forkJoin(dest.map(d => this.job.inputDatasets.addObserveable(d)));
                    }
                    if (obs)
                        obs.subscribe(_ => {
                            this.refreshFiles();
                            this.openSnackBarSuccess('GENERIC.OK');
                        }, e => this.openSnackBarError(e.message));
                    else
                        this.openSnackBarError('PROCESSING.NO_FILES');
                };
                if (!this.job.id) {
                    this.job.saveObservable().subscribe(s => {
                        addFiles();
                    });
                }
                else {
                    addFiles();
                }
            }
            else if (dest instanceof _4d_mapper_1.Folder) {
                // TODO
            }
            else if (dest && Array.isArray(dest)) {
                this.files = dest;
            }
        }, e => this.openSnackBarError(e.message, null));
    }
    start() {
        if (this.jobType) {
            this.job.startTransform(this.jobType.baseTransform, this.arguments).subscribe(s => {
                this.openDialog('GENERIC.SUCCESS' + this.jobType.name + ' MAP.PHOTOGRAM.JOB_STARTED2').subscribe(s => {
                    this.router.navigate(['../..', 'processing'], { relativeTo: this.route });
                });
            }, e => this.openSnackBarError('GENERIC.ERROR ' + e.message));
        }
        else
            this.startAdHoc(this.files[0], this.transformType);
    }
    startAdHoc(d, tt, api) {
        // when its an api specific tak that to end otherwise default
        //var extraURL = params.api ? ('/' + params.api.id) : ''
        this.arguments.for_transform_group = this.mapService.scene.id;
        d.applyTransform(tt, this.arguments).subscribe(s => {
            this.openDialog('GENERIC.SUCCESS' + this.transformType.name + ' MAP.PHOTOGRAM.TASK_STARTED').subscribe(s => {
                this.router.navigate(['../..', 'processing'], { relativeTo: this.route });
            });
        }, e => this.openSnackBarError('GENERIC.ERROR ' + e.message));
    }
    nuke() {
        this.openConfirmDelete(() => {
            this.job.destroyObservable().subscribe(s => {
                this.dataService.sceneJobs.remove(this.job);
                this.openDialog('GENERIC.SUCCESS' + this.jobType.name + ' MAP.PHOTOGRAM.JOB_DELETED').subscribe(s => {
                    this.router.navigate(['../..', 'processing'], { relativeTo: this.route });
                });
            }, e => this.openSnackBarError('GENERIC.ERROR ' + e.message));
        }, this.job.name);
    }
    rmFile(d) {
        if (this.job) {
            this.openConfirmDelete(() => this.job.inputDatasets.removeObservable(d).subscribe(s => {
                this.files = this.files.filter(f => f != d);
            }, e => this.openSnackBarError(e.message)), d.name);
        }
    }
}
exports.ProcessingDetailsComponent = ProcessingDetailsComponent;
